import React from 'react'
import { LucideIcon } from 'lucide-react'

interface SummarySectionProps {
 title: string
 icon: LucideIcon
 iconColor?: string
 children: React.ReactNode
}

export const SummarySection: React.FC<SummarySectionProps> = ({
 title,
 icon: Icon,
 iconColor = 'text-accent',
 children
}) => {
 return (
 <div>
 <div className="flex items-center space-x-2 mb-3 pb-2 border-b-2 border-border">
 <Icon className={`h-5 w-5 ${iconColor}`} />
 <h3 className="font-bold text-lg text-foreground">{title}</h3>
 </div>
 {children}
 </div>
 )
}

